// import React from "react";

// // const MainTitle = () => {

// //     return (
// //         <div className="sticky top-0 py-1 my-2 bg-orange-300" style={{ backgroundColor: "#4B0000" }}>
// //             <div className="text-center text-white">
// //                 <span className="font-bold text-[34px] tracking-tight">Bodeguita de Curicó</span>
// //             </div>
// //         </div>
// //     );
// // }

// // export default MainTitle;


// const MainTitle = () => {
//     return (
//         <div className="sticky top-0 my-2 bg-amber-50 border-t-[3px] border-b-[3px] border-[#4B0000] py-2 px-4">
//             <div className="text-center">
//                 <p className="text-[11px] italic text-amber-800 tracking-widest mb-0" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
//                     paltas hass seleccionadas
//                 </p>
//                 <p className="text-[28px] font-bold text-[#4B0000] leading-tight tracking-tight m-0" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
//                     Bodeguita de Curicó
//                 </p>
//             </div>
//         </div>
//     );
// }

// export default MainTitle;


import React from "react";

const MainTitle = () => {
    return (
        <div className="sticky top-0 z-20 bg-[#2f5a2e] px-4 py-3 shadow-lg lg:py-5">
            <div className="text-center">
                <p
                    className="font-sans font-medium text-[9px] lg:text-[11px] tracking-[0.35em] text-[#cde29a] uppercase mb-0.5 lg:mb-1"
                >
                    paltas hass seleccionadas
                </p>
                <p
                    className="font-serif text-[24px] lg:text-[34px] font-bold text-[#f4f3e6] leading-tight tracking-tight m-0"
                >
                    Frutas Premium
                </p>
            </div>
        </div>
    );
};

export default MainTitle;